import Api from '@/services/Api'

export default {
  get() {
    return Api().get('products').then(function (response) {
      return (response)
    })
  },
  add(newProduct) {
    return Api().post('products', newProduct).then(function (response) {
      return (response)
    })
  },
  getProductById(id) {
    return Api().get(`products/${id}`).then(function (response) {
      return (response)
    })
  },
  partialUpdate(id, data) {
    return Api().patch(`products/${id}`, data).then(function (response) {
      return (response)
    })
  },
}